<script setup lang="ts">
    import { ref } from 'vue';
    import { http } from '@/shared/httpWrapper';
    import { useShippingStore } from '@/stores/shippingStore';
    import { shippingPackageSetName } from '@/shared/helpers/api';
    import useShow from '@/shared/composables/useShow';

    const store = useShippingStore();
    const { showError } = useShow();

    const isEditing = ref(false);
    const name = ref('');

    function onEdit(): void {
        name.value = store.selectedPackage!.name || '';
        isEditing.value = true;
    }

    async function onSave(): Promise<void> {
        try {
            if (!store.selectedPackage) {
                throw new Error('No package selected');
            }
            await shippingPackageSetName(http, store.selectedPackage.packageId, name.value);
            store.selectedPackage.name = name.value;
        } catch {
            showError('Saving name failed!');
        } finally {
            isEditing.value = false;
        }
    }

    function onCancel(): void {
        isEditing.value = false;
    }

</script>

<template>
    <div v-if="isEditing">
        <b-field grouped>
            <b-input
                v-model="name"
                placeholder="Package name"
                maxlength="256" />
            <b-button
                size="is-small"
                icon-left="close"
                @click="onCancel">
                Cancel
            </b-button>
            <b-button
                size="is-small"
                type="is-primary"
                icon-left="floppy"
                @click="onSave">
                Save
            </b-button>
        </b-field>
    </div>
    <span v-else>
        {{ store.selectedPackage?.name || store.selectedPackage?.packageId || 'name missing' }}
        <b-icon
            icon="pencil"
            size="is-small"
            class="is-clickable has-text-grey"
            title="Edit"
            @click="onEdit" />
    </span>
</template>
